module.exports = __webpack_public_path__ + "media/KZ-PAV.c3b781ea.ogg";